export default function hasLibrary (...libraries) {
  return ({ next, store, nextVue }) => {
    const isAuthorized = libraries.some(library => store.getters['client/hasLibrary'](library));

    if (!isAuthorized) {
      return nextVue({ name: 'error' });
    }

    return next();
  };
}
